import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconQrScan = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "QRscan",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 2191 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.83464 5.49984H5.5013V7.83317H7.83464V5.49984ZM4.16797 4.1665V9.1665H9.16797V4.1665H4.16797Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 2193 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.83464 12.1668H5.5013V14.5002H7.83464V12.1668ZM4.16797 10.8335V15.8335H9.16797V10.8335H4.16797Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 2192 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.4987 5.49984H12.1654V7.83317H14.4987V5.49984ZM10.832 4.1665V9.1665H15.832V4.1665H10.832Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 2194",
				d: "M10.832 10.8335H15.832V15.8335H10.832V10.8335Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 122 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.167969 0.833171C0.167969 0.464981 0.466446 0.166504 0.834635 0.166504H4.83464V1.49984H1.5013V4.83317H0.167969V0.833171Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 123 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.832 0.833171C19.832 0.464981 19.5336 0.166504 19.1654 0.166504H15.1654V1.49984H18.4987V4.83317H19.832V0.833171Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 124 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.167969 19.1668C0.167969 19.535 0.466446 19.8335 0.834635 19.8335H4.83464V18.5002H1.5013V15.1668H0.167969V19.1668Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 125 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.832 19.1668C19.832 19.535 19.5336 19.8335 19.1654 19.8335H15.1654V18.5002H18.4987V15.1668H19.832V19.1668Z",
				fill: "#707070"
			})
		]
	})
});
export default SvgIconQrScan;
